<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="search-data">
    <h5 id="tbl-pageTop">Search data by filter</h5>
    <div class="create-booking">
        <ul>
            <li>
                <div class="booking-inner" (click)="surveyListExport()">
                    <img src="../../../../assets/images/export-list.svg" alt="Export list" />
                    <span>Export</span>
                </div>
            </li>
        </ul>
    </div>
</div>
<div class="date-filter">
    <form [formGroup]="filterServeyDateForm" (ngSubmit)="GetParkingLotSurveyDetailsByFilters('search')">
        <div class="grid">
                 <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="startDate">Start Date</label>
                    <div class="custom-select2 custom-date-calender">
                        <p-calendar id="startDate" #startDate formControlName="startDate" [showTime]="false" dateFormat="M dd, yy"
                            inputId="startDateInput" [appEnterKeyListener]="'start'" [inputStyle]="{ width: '95%' }"
                            [readonlyInput]="true" placeholder="Select Date"></p-calendar><img [calendarOpener]="startDate"
                            src="assets/images/date-calender.png" alt="Date calender" />
                    </div>
                </div>
                </div>
                <div class="col-12 lg:col-2">
                    <div class="date-outer">
                        <label for="endDate">End Date</label>
                        <div class="custom-select2 custom-date-calender">
                            <p-calendar id="endDate" #endDate formControlName="endDate" [showTime]="false" dateFormat="M dd, yy"
                                inputId="endDateInput" [appEnterKeyListener]="'end'" [inputStyle]="{ width: '95%' }"
                                [readonlyInput]="true" placeholder="Select Date"></p-calendar><img [calendarOpener]="endDate"
                                src="assets/images/date-calender.png" alt="Date calender" />
                        </div>
                    </div>
                </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="parkingLots">Parking Location<span class="custom-star">*</span></label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter financials-filter">
                            <p-multiSelect id="parkingLots" [options]="parkingLotByStatesListWithAll" formControlName="parkingLots"
                                optionLabel="name" [defaultLabel]="'Select Parking Locations'" [autoZIndex]="true">
                            </p-multiSelect>
                            <img src="assets/images/fill-dropdown.svg" alt="" />
                        </div>
                    </div>
                </div>
                <div class="error-outer">
                    <div *ngIf="filterServeyDateForm.get('parkingLots')?.invalid && filterServeyDateForm.get('parkingLots')?.touched"
                        class="validation-error">
                        This field is required*
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="name">Name</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input id="name" type="text" pInputText placeholder="Enter Name"
                                formControlName="name" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="invoiceNumber">Invoice Number</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input id="invoiceNumber" (input)="onInvoiceInput($event)" type="text" pInputText
                                placeholder="Enter Invoice Number" maxlength="15" formControlName="invoiceNumber" />
                        </div>
                    </div>
                </div>
            </div>

<div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer">
                        <p-button styleClass="p-button search-button" [type]="'submit'" label="Apply Filter"></p-button>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer reset-btn">
                        <p-button styleClass="p-button  p-button-outlined" label="Reset"
                            (onClick)="resetSurveyListFilter()"></p-button>

                    </div>    
                </div>
            </div>
        </div>
    </form>
</div>

<div class="driver-list-outer">
    <div class="list-heading">
        <h4>Experience Survey</h4>
        <div class="page-list filter-parking">
            <p>Show
                <p-dropdown [(ngModel)]="searchItemPerPageBy" name="searchItemPerPageBy" [options]="customItemPerPageBy" placeholder="10"
                    optionLabel="name" (onChange)="onDropdownChange($event)" optionValue="value"></p-dropdown><img
                    src="assets/images/fill-dropdown.svg" alt="" />
                Records
            </p>
        </div>
    </div>
    <div class="card parking-list survey-list-table">

        <p-table id="tbl-top" [value]="surveyList" [resizableColumns]="true" columnResizeMode="expand">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col" class="custom-addres">Parking Location</th>
                    <th scope="col">Invoice Number</th>
                    <th scope="col">Arrival Date & Time</th>
                    <th scope="col">Departure Date & Time</th>
                    <th scope="col">Submitted Date</th>
                    <th scope="col">Feedback</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr class="border12">
                    <td class="cursor-pointer" (click)="navigateToBookingDetailsScreen(rowData.userType, rowData.bookingId)">
                        <div class="driver-names"><img [src]="(rowData.userProfileImage)?rowData.userProfileImage:dummy"
                                alt="Profile" /><span>{{
                                rowData.groupName ? rowData.groupName : rowData.name
                                }}</span></div>
                    </td>
                    <td>
                        <div class="custom-text common-custom-text">
                            <ng-container>
                                <h5>{{ rowData.parkingLotName ? rowData.parkingLotName : '-' }}</h5>
                                <p class="address-text">{{ rowData.parkinglotAddress ? rowData.parkinglotAddress : '-' }}</p>
                            </ng-container>

                        </div>
                    </td>
                    <td>
                        <div class="driver-email">{{rowData.invoiceNumber || '-'}}</div>
                    </td>
      
                    <td>{{ rowData.startDate | luxonFormat}}</td>
                    <td>{{ rowData.endDate | luxonFormat}}</td>
                     <td>{{ rowData?.submittedDate | luxonFormat:'MMM d, yyyy' }}</td>
                    <td>
                        <div class="custom-text rating-emoji-outer"
                            *ngIf="getSelectedRating(rowData?.parkingExperinceRating) as rating">
                            <ng-container>
                                <div class="rating-emoji">
                                    <h5>{{ rating.label }}</h5>
                                    <img [src]="rating.emoji" alt="">
                                </div>
                                <p class="address-text">{{ rating.desc }}</p>
                            </ng-container>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr class="no-border">
                    <td class="no-record" colspan="7">
                        <div class="survey-record">
                            No Record Found
                        </div>

                    </td>
                </tr>
            </ng-template>

        </p-table>

        <div class="card common-content-end custom-pagination2" *ngIf="surveyList?.length > 0">
            <p-paginator [first]="currentSkip" [rows]="itemsPerPage" [totalRecords]="surveyListTotalRecords"
                (onPageChange)="onPageChange($event)"></p-paginator>
        </div>
    </div>
</div>